<script>
import DynamicAppTextElement
  from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/display/DynamicAppTextElement.vue";
import AppPaletteFieldPolicy from "%/dynamic-component-editor/classes/app-palette-field-policy";

const EXTERNAL_URL_PATTERN = /^https?:\/\//i;

export default {
  name: "DynamicAppLinkElement",
  extends: DynamicAppTextElement,
  elementPanelSettings: {
    displayName: "Link",
    elementGroup: "general",
    displayIcon: "hyperlink",
    elementType: "element",
  },
  hidden: true,
  computed: {
    linkUrl() {
      const url = this.valueFromContext;
      return typeof url === "string" && EXTERNAL_URL_PATTERN.test(url.trim()) ? url.trim() : "";
    },
    linkLabelField() {
      return AppPaletteFieldPolicy.linkLabelFieldFor(
        this.elementContext?.appName,
        this.entityType,
        this.elementContext?.field,
      );
    },
    linkLabel() {
      const label = this.siblingFieldValue(this.linkLabelField);
      return typeof label === "string" ? label.trim() : "";
    },
    linkLabelDefault() {
      const label = this.relatedEntity?.fields?.[this.linkLabelField]?.default;
      return typeof label === "string" ? label.trim() : "";
    },
    value() {
      if (this.editMode || this.isPreviewMode) {
        return this.linkLabel || this.linkLabelDefault || this.placeholderText;
      }
      return this.linkUrl ? this.linkLabel || this.linkUrl : "";
    },
    placeholderText() {
      return AppPaletteFieldPolicy.linkDisplayName(this.elementContext?.field) || "Link";
    },
    shouldShowText() {
      return this.editMode || this.isPreviewMode || this.linkUrl !== "";
    },
    entityPageHref() {
      if (this.editMode || this.isPreviewMode) {
        return null;
      }
      return this.linkUrl || null;
    },
    openInNewTab() {
      return true;
    },
  },
};
</script>
